import React, { useCallback, useState, memo } from "react";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

const headCells = [
  "Select",
  "Mbr#",
  "Store Name",
  "Contact Person",
  "Phone",
  "Delivery Street Address",
  "Delivery City",
  "Delivery State",
  "Country",
  "Delivery Zip Code",
  "Distribution Center",
  "Store Size",
  "Lineal Footage",
  "Project Type",
  "Project Planner",
  "Assigned MAC",
  "Credit Limit",
  "Created On",
];

const StoreDialogContent = (props) => {
  const { rows = [], handleStoreSelection } = props;
  const [currentSelection, setCurrentSelection] = useState(0);

  const handleRowSelection = useCallback(
    (event) => {
      const currentSelection = Number(event.target.value);
      setCurrentSelection(currentSelection);
      handleStoreSelection(currentSelection);
    },
    [handleStoreSelection]
  );

  return (
    <>
      <Typography mb={2}>Select store details from below table:</Typography>
      <TableContainer component={Paper} sx={{ maxHeight: 290 }}>
        <Table
          stickyHeader
          sx={{ minWidth: 850 }}
          aria-label="store details table"
        >
          <TableHead>
            <TableRow>
              {headCells.map((headCell, i) => (
                <TableCell
                  key={i}
                  padding="none"
                  sx={{
                    pl: 1,
                    py: 1,
                    fontWeight: "bold",
                    backgroundColor: "#E7E7E7",
                  }}
                >
                  {headCell}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow
                hover
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                key={i}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    maxWidth: 50,
                  }}
                >
                  <FormControlLabel
                    onChange={handleRowSelection}
                    checked={currentSelection === i}
                    value={i}
                    control={<Radio />}
                    label=""
                  />
                </TableCell>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 75,
                  }}
                >
                  <Tooltip title={row?.new_membernumber ?? ""} arrow>
                    <span>{row?.new_membernumber}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_storename.name ?? ""} arrow>
                    <span>{row?.new_storename.name}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_storecontactname ?? ""} arrow>
                    <span>{row?.new_storecontactname}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 70,
                  }}
                >
                  <Tooltip title={row?.new_cellphone ?? ""} arrow>
                    <span>{row?.new_cellphone}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_mailingstreet ?? ""} arrow>
                    <span>{row?.new_mailingstreet}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_city ?? ""} arrow>
                    <span>{row?.new_city}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_state ?? ""} arrow>
                    <span> {row?.new_state}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_country ?? ""} arrow>
                    <span> {row?.new_country}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 50,
                  }}
                >
                  <Tooltip title={row?.new_zipcode ?? ""} arrow>
                    <span>{row?.new_zipcode}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_rdc ?? ""} arrow>
                    <span>{row?.new_rdc}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 70,
                  }}
                >
                  {!!row?.new_tvhardwaresqft ? (
                    <Tooltip title={`${row?.new_tvhardwaresqft} sq ft`} arrow>
                      <span>{row?.new_tvhardwaresqft} sq ft</span>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 70,
                  }}
                >
                  {!!row?.new_tvlineal ? (
                    <Tooltip title={`${row?.new_tvlineal} sq ft`} arrow>
                      <span>{row?.new_tvlineal} sq ft</span>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_projecttype ?? ""} arrow>
                    <span>{row?.new_projecttype}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip
                    title={row?.new_dtvprojectplannerid?.new_name ?? ""}
                    arrow
                  >
                    <span>{row?.new_dtvprojectplannerid?.new_name}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.new_macid?.new_name ?? ""} arrow>
                    <span>{row?.new_macid?.new_name}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 70,
                  }}
                >
                  {!!row?.new_estosoamount ? (
                    <Tooltip title={`$ ${row?.new_estosoamount}`} arrow>
                      <span>$ {row?.new_estosoamount}</span>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell
                  sx={{
                    pl: 1,
                    display: "table-cell",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 100,
                  }}
                >
                  <Tooltip title={row?.createdon ?? ""} arrow>
                    <span>{row?.createdon}</span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default memo(StoreDialogContent);
